"use client";

import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import AddressAndLanguage from "../../../../(root)/home/components/AddressSelect";

interface MobileMenuProps {
  isOpen: boolean;
  onNavigate: (path: string) => void;
  onSectionNavigate: (sectionId: string) => void;
  onClose: () => void;
}

const MobileMenu = forwardRef<HTMLDivElement, MobileMenuProps>(
  ({ isOpen, onNavigate, onSectionNavigate, onClose }, ref) => {
    const { t } = useTranslation();

    return (
      <>
        {isOpen && (
          <button
            type="button"
            aria-label="Close navigation menu"
            onClick={onClose}
            className="fixed inset-x-0 top-[56px] bottom-0 z-[60] bg-black/40 md:hidden"
          />
        )}
        <div
          ref={ref}
          aria-hidden={!isOpen}
          style={{ height: isOpen ? "calc(100dvh - 56px)" : 0 }}
          className={`mobile-menu md:hidden absolute left-0 right-0 top-full z-[70] w-full overflow-hidden bg-white shadow-xl transition-[height,opacity] duration-300 ${
            isOpen ? "opacity-100" : "pointer-events-none opacity-0"
          }`}
        >
          <nav className="flex h-full flex-col overflow-y-auto px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))]">
            <div className="border-b border-gray-200 py-2">
              <AddressAndLanguage />
            </div>
            <p className="pt-5 pb-2 text-xs font-semibold uppercase tracking-wider text-gray-500">
              Browse
            </p>
            <div className="flex flex-col divide-y divide-gray-100">
              <button
                onClick={() => onSectionNavigate("newarrivals")}
                className="py-4 text-left text-base font-medium text-gray-900 transition-colors hover:text-red-600"
              >
                {t("newArrivals")}
              </button>
              <button
                onClick={() => onSectionNavigate("mostwanted")}
                className="py-4 text-left text-base font-medium text-gray-900 transition-colors hover:text-red-600"
              >
                {t("mostWanted")}
              </button>
              <button
                onClick={() => onNavigate("/categories")}
                className="py-4 text-left text-base font-medium text-gray-900 transition-colors hover:text-red-600"
              >
                {t("categories")}
              </button>
            </div>
          </nav>
        </div>
      </>
    );
  }
);

MobileMenu.displayName = "MobileMenu";

export default MobileMenu;
